import compInfos from "./upload-new-file.json";
import { useLangContext } from "../../../../../context/langContext";
import { useFilesContext } from "../../../../../context/myFilesContext";
import UploadNewFileForm from "../../../../../forms/upload-new-file/UploadNewFileForm";
import MuiBaseModal from "../../../../common/modal/MuiModal";

export default function UploadNewFileModal() {
  const { newUploadOpen, onCloseNewUpload } = useFilesContext();
  const { lang, dir } = useLangContext();

  const infos = compInfos[lang];

  return (
    <MuiBaseModal
      open={newUploadOpen}
      onClose={onCloseNewUpload}
      title={infos.title}
      subTitle={infos.subTitle}
      hasCloseIcon
    >
      <UploadNewFileForm />
    </MuiBaseModal>
  );
}
